// ClauseBuilder.jsx
function ClauseBuilder({ fields, clause, onUpdate, onDelete }) {
  const operators = ['=', '!=', '>', '<','>=', '<=', 'LIKE'];
  const dataTypes = ['INT', 'FLOAT', 'BOOL', 'STRING','DATE','RAW'];

  return (
    <div  style={{backgroundColor: '#957bbe' }} className="form-row align-items-center mb-2 text-white  border rounded border-primary px-4 py-2">
      {clause.type === "RAW" ? (
       <div className="row d-flex gap-2 mt-2">
         <input
           className="form-control col-12"
           value={clause.value}
           onChange={e => onUpdate({ ...clause, value: e.target.value })}
           placeholder="Enter raw SQL expression (e.g. TIMESTAMP_SUB(CURRENT_TIMESTAMP(), INTERVAL 7 DAY))"
         />
         <select className="form-control col-3 d-none" value={clause.type} 
           onChange={e => onUpdate({ ...clause, type: e.target.value })}>
           {dataTypes.map(t => <option key={t}>{t}</option>)}
         </select>
         <select className="form-control col" value={clause.type} onChange={e => onUpdate({ ...clause, type: e.target.value })}>
              {dataTypes.map(t => <option key={t}>{t}</option>)}
            </select>
         <i onClick={onDelete} className="fa-solid fa-trash col text-danger mt-2"></i> 
       </div>
     ) : (
       <><select
        className="form-control row"
        value={clause.column}
        onChange={e => onUpdate({ ...clause, column: e.target.value })}
      >
        <option value="">-- Select Column --</option>
        {fields.map(field => (
          <option key={field} value={field}>
            {field}
          </option>
        ))}
      </select>
        <div className="row d-flex justify-content-between gap-2 mt-2">
            <select className="form-control col" value={clause.op} onChange={e => onUpdate({ ...clause, op: e.target.value })}>
              {operators.map(o => <option key={o} >{o}</option>)}
            </select>
            <input className="form-control col" value={clause.value} onChange={e => onUpdate({ ...clause, value: e.target.value })} />
            <select className="form-control col" value={clause.type} onChange={e => onUpdate({ ...clause, type: e.target.value })}>
              {dataTypes.map(t => <option key={t}>{t}</option>)}
            </select>
            <i  onClick={onDelete} className="fa-solid fa-trash col text-danger mt-2"></i> 
            </div></>)}
    </div>
  );
}
export default ClauseBuilder